import React, { FC } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import { useTranslation } from '@aarhus-university/au-lib-react-components/src/lib/hooks';
import { LangContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import SelfServiceFrontComponent from '../components/selfservice/SelfServiceFrontComponent';
import CreateAUIDComponent from '../components/selfservice/CreateAUIDComponent';
import CreateCPRComponent from '../components/selfservice/CreateCPRComponent';
import CreateFormComponent from '../components/selfservice/CreateFormComponent';
import InvalidContextComponent from '../components/common/InvalidContextComponent';
import { defaultLabels, importJson, TranslationsContext } from '../lib/translation';
import { getContextFromQuery } from '../lib/helpers';
import { useGetRegistrationContextQuery } from '../services/api';
import { RegistrationContext } from '../lib/context';

declare global {
  interface Window {
    appLang: string,
  }
}

const SelfServiceWrapperComponent: FC = () => {
  const lang = window.appLang;
  const translations = useTranslation(defaultLabels, [importJson('user-registration', lang), null], lang);
  const query = getContextFromQuery();

  const { data: context, isLoading } = useGetRegistrationContextQuery(query, {
    skip: !query,
  });
  return (
    <LangContext.Provider value={lang}>
      <TranslationsContext.Provider value={translations}>
        <RegistrationContext.Provider value={isLoading ? null : context}>
          <InvalidContextComponent allowed="selfservice">
            <Router>
              <Routes>
                <Route path={`/${lang}/create-account`} element={<SelfServiceFrontComponent />} />
                <Route path={`/${lang}/create-account/ldap`} element={<CreateAUIDComponent />} />
                <Route path={`/${lang}/create-account/cpr`} element={<CreateCPRComponent />} />
                <Route path={`/${lang}/create-account/form`} element={<CreateFormComponent />} />
              </Routes>
            </Router>
          </InvalidContextComponent>
        </RegistrationContext.Provider>
      </TranslationsContext.Provider>
    </LangContext.Provider>
  );
};

SelfServiceWrapperComponent.displayName = 'SelfServiceWrapperComponent';
export default SelfServiceWrapperComponent;
